import { render, staticRenderFns } from "./AudienceCustomers.vue?vue&type=template&id=6ba81a7c&scoped=true"
import script from "./AudienceCustomers.vue?vue&type=script&lang=js"
export * from "./AudienceCustomers.vue?vue&type=script&lang=js"
import style0 from "./AudienceCustomers.vue?vue&type=style&index=0&id=6ba81a7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba81a7c",
  null
  
)

export default component.exports